import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#000000", // Black
    },
    secondary: {
      main: "#ffffff", // White
    },
    background: {
      default: "#f8f8f8",
      paper: "#ffffff",
    },
    text: {
      primary: "#000000",
      secondary: "#555555",
    },
  },
  typography: {
    fontFamily: '"Arial", sans-serif',
    fontWeightBold: 700,
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
        },
        contained: {
          backgroundColor: "#000",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#444",
            color: "#fff",
          },
        },
        outlined: {
          border: "2px solid #000",
          color: "#000", // ✅ outlined buttons use black text
          "&:hover": {
            backgroundColor: "#f0f0f0",
            borderColor: "#000",
            color: "#000",
          },
        },
        text: {
          color: "#000", // optional, makes text buttons black too
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          color: "black",
          borderBottom: "1px solid #444",
          boxShadow: "none",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: "1000px",
          margin: "auto",
          padding: "20px",
        },
      },
    },
  },
});

export default theme;
